export type UserId = string;

export interface User {
  ID: UserId;
  Name: string;
  Username: string;
  Email?: string;
  Roles?: number;
  TOTPEnabled?: boolean;
}

export interface UserPatch {
  Name?: string;
  Email?: string;
}

export const USER_ROLE_ROOT_ADMIN = 0b10000000;
export const USER_ROLE_ADMIN = 0b01000000;
export const USER_ROLE_EMULATOR = 0b00100000;

export interface NewUser {
  Code: string;
  Username: string;
  Password: string;
  PasswordConfirm: string;
  Email: string;
  Name: string;
}
